'use strict';
const _ = require('underscore');
const Backbone = require('backbone');
const ContentAPI = require('data/infra/api/content/index');
const ContentFactory = require('data/domain/factory/content/index');
const ContentCollection = require('data/domain/collection/content/index');

class Repository {
    constructor(project) {
        this._project = project;
        this._allContents = new Backbone.Collection();
        this._containerContents = {};
        this._fetched = {};
    }

    _getContainerContents(containerID) {
        if(!this._containerContents[containerID]) {
            this._containerContents[containerID] = new ContentCollection(null, {}, {
                containerID: containerID,
                repository: this
            });
        }

        return this._containerContents[containerID];
    }

    add(content) {
        this._allContents.add(content, {merge: true});
        return this._getContainerContents(content.getContainer().id).add(content, {merge: true});
    }

    update(content, contentJSON) {
        return ContentAPI.updateContent(this._project.id, content.id, contentJSON)
            .then(contentJSON => {
                const factory = new ContentFactory(this._project);
                return factory.build(contentJSON);
            })
            .then(content => {
                return this.add(content);
            });
    }

    on(event, callback) {
        this._allContents.on(event, callback);
    }

    getContent(contentID) {
        return this._allContents.get(contentID);
    }

    fetchContent(contentID) {
        return new Promise((resolve, reject) => {
            ContentAPI.fetchContent(this._project.id, contentID, {noRaise: true})
                .then(contentJSON => {
                    const factory = new ContentFactory(this._project);
                    return factory.build(contentJSON);
                })
                .then(content => {
                    this.add(content);
                    resolve(content);
                }, reject);
        });
    }

    fetchContentOnce(contentID) {
        const content = this.getContent(contentID);
        if (content) {
            return new Promise((resolve, reject) => {
                resolve(content);
            })
        } else {
            return this.fetchContent(contentID);
        }
    }

    getContents(containerID) {
        return this._getContainerContents(containerID);
    }

    fetchContents(containerID, limit, cursor) {
        const containerContents = this._getContainerContents(containerID);

        return new Promise((resolve, reject) => {
            ContentAPI.fetchContents(
                this._project.id, containerID, limit, cursor
            ).then(data => {
                this._fetched[containerID] = true;
                containerContents.setCursor(data.cursor);
                containerContents.setNext(data.more);

                const factory = new ContentFactory(this._project);

                return Promise.all(
                    _.map(data.contents, j => factory.build(j))
                )
            }).then(contents => {
                _.each(contents, c => this.add(c));

                resolve(containerContents);
            }, reject);
        })
    }

    fetchContentsOnce(containerID, limit) {
        if(this._fetched[containerID]) {
            return new Promise((resolve, reject) => {
                resolve(this._getContainerContents(containerID));
            });
        } else {
            return this.fetchContents(containerID, limit);
        }
    }

    deleteContent(content) {
        return ContentAPI.deleteContent(
            this._project.id, content.id
        )
            .then(contentJSON => {
                const factory = new ContentFactory(this._project);
                return factory.build(contentJSON);
            })
            .then(content => {
                return this.add(content);
            });
    }
}

const repositories = {};

const find = function(project) {
    let r = repositories[project.id];
    if (!r) {
        r = new Repository(project);
        repositories[project.id] = r;
    }
    return r;
};

module.exports = {
    find: find
};



// WEBPACK FOOTER //
// ./data/domain/repository/content/index.js